<template>
  <div>
    <q-card class="auth-card relative-position">
      <q-card-main>
        <check-mark></check-mark>

        <h4 class="text-center">{{ $t('team_deleted_confirmation_title') }}</h4>

        <p class="text-center">{{ $t('team_deleted_confirmation_body') }}</p>
      </q-card-main>
    </q-card>
  </div>
</template>

<script>
  import CheckMark from 'components/Common/Animations/Checkmark.vue'
  import router from 'src/router'
  import store from 'src/store'

  export default {
    beforeRouteEnter (to, from, next) {
      let token = to.params.token

      store.dispatch('removeTeam', token)
        .then(() => {
          setTimeout(() => {
            router.push({ name: 'login' })
          }, 5000)

          next()
        })
    },

    components: {
      CheckMark
    }
  }
</script>
